module.exports = __webpack_public_path__ + "static/media/vedantu.1ac491d2.png";